import { render } from "./cookiePolicy.vue?vue&type=template&id=1c44fac6&scoped=true"
import script from "./cookiePolicy.vue?vue&type=script&lang=js"
export * from "./cookiePolicy.vue?vue&type=script&lang=js"

import "./cookiePolicy.vue?vue&type=style&index=0&id=1c44fac6&scoped=true&lang=sass"
import "./cookiePolicy.vue?vue&type=style&index=1&id=1c44fac6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c44fac6"]])

export default __exports__